import { ApiError } from '../services/api/apiError';

/** Backend validation errors -> { field: message }. `map` renames API paths to form keys. */
export function serverFieldErrors(err: unknown, map: Record<string, string> = {}): Record<string, string> {
  if (!(err instanceof ApiError)) return {};
  return Object.fromEntries(Object.entries(err.fieldErrors()).map(([k, v]) => [map[k] ?? k, v]));
}

export const PHONE_RX = /^\d{10}$/;
export const GSTIN_RX = /^\d{2}[A-Z]{5}\d{4}[A-Z][A-Z\d]Z[A-Z\d]$/;
export const cleanPhone = (p = '') => p.replace(/\s/g, '');
export const trimOrUndef = (s?: string | null) => (s && s.trim() ? s.trim() : undefined);
